import { NgModule } from '@angular/core';
import { CopMatrixComponent, CopMatrixPopupComponent } from './cop-matrix.component';
import { BmsjHipsterSharedModule } from '../shared';
import { RouterModule } from '@angular/router';
import { COP_ROUTES } from './cop.route';
import { CopService } from './cop.service';
import { HelpLinkComponent } from '../shared/help-link/help-link.component';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild(COP_ROUTES),
        HelpLinkComponent
    ],
    declarations: [
        CopMatrixComponent,
        CopMatrixPopupComponent,
    ],
    providers: [
        CopService
    ],
    exports: [
        CopMatrixComponent
    ]
})
export class CopModule {
}
